<script lang="ts">

  import { createEventDispatcher } from 'svelte';

  export let values: any[];
  export let name: string = 'random';

  let selected: number[] = [];

  const check = (value: any) => {
    if (selected.includes(value)) {
      selected = selected.filter(s => s !== value);
    } else {
      selected = [...selected, value];
    }
    dispatchCurrentValue();
  }

  const dispatch = createEventDispatcher<{ valueChange: any[] }>();

  const dispatchCurrentValue = () => {
    dispatch('valueChange', selected)
  }

</script>
<div class="row">
  <div class="col-auto">
    <slot></slot>
  </div>
</div>
<div class="row">
  <div class="col-auto">
    <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
      {#each values as value, index}
        <input type="checkbox"
               class="btn-check"
               name="{name}{index}"
               id="{name}{index}"
               autocomplete="off"
               on:change={() => check(value)}>
        <label class="btn btn-outline-primary"
               for="{name}{index}">
          {value}
        </label>
      {/each}
    </div>
  </div>
</div>
